import * as React from 'react';
import * as moment from 'moment';
import Store from '../stupid-date-picker/store';
import StupidDatePicker from '../stupid-date-picker/date-picker';
import StupidTimePicker from '../stupid-date-picker/time-picker';


interface IStupidDatePickerUsageProps {
  store: Store;
}

export default class StupidDatePickerUsage extends React.Component<IStupidDatePickerUsageProps>{

  private onDateChange = (date: moment.Moment, dateString: string) => {
    const { store } = this.props;
    const { showTime } = store.config;
    store.setValue(date);
    if (!showTime && store.config.onChange) {
      store.config.onChange(date, dateString);
    }
  }

  private onDateOk = (date: moment.Moment) => {
    const { store } = this.props;
    const { showTime } = store.config;
    if (showTime && store.config.onChange) {
      store.config.onChange(date, '');
      store.closePicker();
    }
  }

  private onTimeChange = (date: moment.Moment, dateString: string) => {
    const { store } = this.props;
    store.setValue(date);
    if (store.config.onChange) {
      store.config.onChange(date, dateString);
    }
  }

  public render() {
    const { store } = this.props;
    const { left, top } = store.position;
    const { isTimePicker, showTime } = store.config;

    if (isTimePicker) {
      return (
        <StupidTimePicker
          value={store.value}
          style={{ left, top }}
          onChange={this.onTimeChange}
          open={store.isPickerOpened}
          onClickAway={() => store.closePicker()}
        />
      );
    }

    return (
      <StupidDatePicker
        value={store.value}
        style={{ left, top }}
        onChange={this.onDateChange}
        onOk={this.onDateOk as any}
        open={store.isPickerOpened}
        onClickAway={() => store.closePicker()}
        showTime={showTime}
      />
    );
  }
}
